export class UnitPhone {
  constructor(
    /** Country code of the phone number, e.g. "1" for US. */
    public countryCode: string = null,
    /** The phone number without the country code, e.g. "4151193497". */
    public number: string = null
  ) {
  }
}

export namespace UnitPhone {
  export function fromFormValue(value: string) {
    try {
      if (!value) {
        return null;
      }
      var separatorIndex = value.indexOf(' ');
      const countryCode = value.slice(0, separatorIndex).replace('+', '').trim();
      const number = value.slice(separatorIndex).trim();
      return new UnitPhone(countryCode, number);
    } catch {
      console.log(`Couldn't parse phone number string: ${value}`);
      return null;
    }
  }

  export function toFormValue(phone: UnitPhone): string {
    return phone && phone.countryCode && phone.number ? `+${phone.countryCode} ${phone.number}` : null;
  }
}
